var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid-xs leading-tightest border rounded p-4 [&_a]:font-medium [&_a]:underline",class:_vm.colorStyle},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }